import React from 'react';
import { RUC, DNI } from '../../../common/types/tipoDocumentoType';
import { FORMAT_EMAIL, FORMAT_NUMBER } from '../../../common/types/regularExpresionType';
import {
    Modal,
    Input,
    Form,
    Select,
    Progress,
    Checkbox,
    Switch,
    Icon 
} from 'antd';
const InputGroup = Input.Group;
const { Option } = Select;
const { Search } = Input;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordProgress: 0
        }
    }

    numeroDocumentoCustomValidation = (rule, value, callback) => {
        var idTipoDocumento = this.props.form.getFieldValue('idTipoDocumento')?.key;
        if (idTipoDocumento !== undefined) {
            var numeroDocumentoLongitud = this.props.form.getFieldValue('numeroDocumento').length;
            var longitud = idTipoDocumento === RUC.ID ? 11 : 8;
    
            if ([RUC.ID, DNI.ID].includes(idTipoDocumento))
            {
                var regexp = new RegExp(FORMAT_NUMBER);
                if (!regexp.test(value))
                    callback(`Formato ${idTipoDocumento === RUC.ID ? 'RUC' : 'DNI'} invalido.`);
                else if (numeroDocumentoLongitud !== longitud && numeroDocumentoLongitud > 0)
                    callback('La longitud de ser de ' + longitud + ' caracteres.');
            }    
        }
        callback();
    }

    correoCustomValidation = (rule, value, callback) => {
        var regexp = new RegExp(FORMAT_EMAIL);
        if (value === undefined || value === null || value.length === 0 || !regexp.test(value))
            callback('Formato de correo invalido.');
            
        callback();
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err){
                const form = {
                    id: values.id,
                    usuario: values.usuario.trim(),
                    password: values.password,
                    idTipoDocumento: values.idTipoDocumento.key,
                    nombre: values.nombre.trim(),
                    numeroDocumento: values.numeroDocumento.trim(),
                    apellidoPaterno: values.apellidoPaterno,
                    apellidoMaterno: values.apellidoMaterno,
                    correo: values.correo,
                    idRol: values.idRol.key,
                    flagPermisoComprobanteContingencia: values.flagPermisoComprobanteContingencia,
                    flagPermisoCaja: values.flagPermisoCaja
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Usuario" : "Modificar Usuario"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form autoComplete="nope">
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Usuario">
                                {getFieldDecorator('usuario', {
                                    initialValue: this.props.formValues.usuario,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    },{
                                        pattern: /^\S*$/,
                                        message: 'Ingrese un usuario correcto.',
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar usuario"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    {
                        this.props.formValues.id > 0 ? null : 
                        <div className="row">
                            <div className="col-md-12 form-group">
                                <Form.Item label="Contraseña">
                                <InputGroup compact>
                                    {getFieldDecorator('password', {
                                        initialValue: this.props.formValues.password,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar contraseña"
                                            autoComplete="off"
                                            type="password"
                                        />
                                    )}
                                      {/* <Progress percent={this.state.passwordProgress} status="exception" size="small" /> */}
                                      <h5 className="rb-5">La contraseña debe contener al menos 1 minúscula, 1 mayúscula, 1 número y</h5>
                                      <h5 className="rt-5">1 caracter especial (@#$%^&+=).</h5>
                                  </InputGroup>
                                </Form.Item>
                            </div>
                        </div>
                        
                    }

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Tipo de Documento">
                                {getFieldDecorator('idTipoDocumento', {
                                    initialValue: this.props.formValues.idTipoDocumento > 0 ?
                                        { key: this.props.formValues.idTipoDocumento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione tipo de documento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.tiposDocumento.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Número de documento">
                                {getFieldDecorator('numeroDocumento', {
                                    initialValue: this.props.formValues.numeroDocumento,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    },
                                    {
                                        validator: this.numeroDocumentoCustomValidation
                                    }
                                ]
                                })(
                                    <Search
                                    placeholder="Búsqueda por Documento"
                                    autoComplete="off"
                                    maxLength={50}
                                    loading={this.props.formValues.searchLoading}
                                    onSearch={value => this.props.onBuscarPadronReducido(this.props.form.getFieldValue('idTipoDocumento').key, value, this.props.form)}
                                /> 
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Apellido Paterno">
                                {getFieldDecorator('apellidoPaterno', {
                                    initialValue: this.props.formValues.apellidoPaterno
                                })(
                                    <Input
                                        placeholder="Ingresar apellido paterno"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Apellido Materno">
                                {getFieldDecorator('apellidoMaterno', {
                                    initialValue: this.props.formValues.apellidoMaterno
                                })(
                                    <Input
                                        placeholder="Ingresar apellido materno"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Correo">
                                {getFieldDecorator('correo', {
                                    initialValue: this.props.formValues.correo,
                                    rules: [
                                    {
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        validator: this.correoCustomValidation
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar correo"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Rol">
                                {getFieldDecorator('idRol', {
                                    initialValue: this.props.formValues.idRol > 0 ?
                                        { key: this.props.formValues.idRol } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione rol"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.roles.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row" hidden={true}>                  
                        <div className="col-md-12 form-group">
                            <Form.Item label="Permiso - Comprobante Contingencia">
                                {getFieldDecorator('flagPermisoComprobanteContingencia', {
                                    initialValue: this.props.formValues.flagPermisoComprobanteContingencia,
                                    valuePropName: 'checked'
                                })(
                                  <Switch checkedChildren="Aprobado" unCheckedChildren="Rechazado"  />                                
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Responsable - Caja Cobranza">
                                {getFieldDecorator('flagPermisoCaja', {
                                    initialValue: this.props.formValues.flagPermisoCaja,
                                    valuePropName: 'checked'
                                })(
                                  <Switch checkedChildren="SI" unCheckedChildren="NO"  />                                
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)